import axios from 'axios'

class Products {
  constructor (data) {
    this.id = data.id // 产品id
    this.name = data.name // string 产品名称
    this.prjectCode = data.prjectCode // string 项目代号
    this.number = data.number // string 产品编号
    this.snRange = data.snRange // string sn地址范围（JSON字符串）
    this.snRanges = data.snRanges // array sn地址范围
    this.tag = data.tag // 项目标签
  }
}

/**
 * 获取所有的产品
 * @return {Array}
 */
export const getList = async () => {
  const {data} = await axios.get('v1/products')
  const list = data.map(item => new Products(item))
  return { list, total: data.length }
}

/**
 * 添加产品
 * @param  {*Object} data
 * @return {Object}
 */
export const addProduct = async (data) => {
  await axios.post('v1/products', data)
}

/**
 * 更新产品信息
 * @param  {*Object} data
 * @return {Object}
 */
export const upadtaProduct = async (data) => {
  await axios.put(`v1/products/${data.id}`, data)
}
